import { useState } from "react";

const testimonials = [
  {
    quote:
      "We used to have one person whose entire job was handling intake calls and booking consultations. Now that&apos;s done automatically. She now focuses on client relationships — which is where her skills actually belong.",
    name: "Sarah Dunne",
    title: "Managing Partner",
    company: "Dunne & Associates Solicitors",
    industry: "Law Firm",
    image:
      "https://public.readdy.ai/ai/img_res/0302526124f884bcf1c107f1eb806a73.jpg",
  },
  {
    quote:
      "The Project Experts transformed how we handle our operations. Documents that took our team hours to process are now summarised and filed automatically. It&apos;s genuinely transformative.",
    name: "Marcus Hoffman",
    title: "Operations Director",
    company: "Hoffman & Partners Consulting",
    industry: "Consulting Firm",
    image:
      "https://readdy.ai/api/search-image?query=professional%20businessman%20portrait%20confident%20executive%20consultant%20corporate%20headshot%20smart%20blazer%20natural%20lighting%20clean%20neutral%20background&width=200&height=200&seq=avatar-2&orientation=squarish",
  },
  {
    quote:
      "We were sceptical at first — but within two weeks, our scheduling backlog was gone. The AI handles everything from first enquiry to confirmed appointment. Our team can&apos;t imagine going back.",
    name: "Claire Reeves",
    title: "Head of Client Services",
    company: "Reeves Manufacturing Ltd",
    industry: "Manufacturing",
    image:
      "https://readdy.ai/api/search-image?query=professional%20woman%20portrait%20confident%20smile%20manufacturing%20executive%20corporate%20headshot%20business%20attire%20natural%20lighting%20clean%20background&width=200&height=200&seq=avatar-3&orientation=squarish",
  },
];

export default function TestimonialsSection() {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section className="py-24 bg-[#040810]">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="text-electric-400 text-xs font-semibold uppercase tracking-widest">Customer Stories</span>
          <h2 className="mt-3 text-4xl font-extrabold text-white">Real Results. Real Businesses.</h2>
        </div>

        <div className="bg-[#0D1628] border border-white/8 rounded-3xl p-8 lg:p-12 grid lg:grid-cols-[160px_1fr] gap-8 items-start">
          <div className="flex lg:flex-col items-center gap-4 lg:gap-3">
            <div className="w-16 h-16 lg:w-full lg:h-auto lg:aspect-square rounded-2xl overflow-hidden border-2 border-electric-500/30 shrink-0">
              <img
                alt={t.name}
                className="w-full h-full object-cover object-top"
                src={t.image}
              />
            </div>
            <div className="lg:text-center">
              <p className="text-white font-semibold text-sm">{t.name}</p>
              <p className="text-slate-400 text-xs mt-0.5">{t.title}</p>
              <p className="text-electric-400 text-xs font-medium mt-0.5">{t.company}</p>
            </div>
          </div>

          <div>
            <i className="ri-double-quotes-l text-6xl text-electric-500/30 leading-none block -mb-3"></i>
            <blockquote className="text-white text-xl font-medium leading-relaxed italic">
              {t.quote}
            </blockquote>
            <p className="text-slate-500 text-sm mt-4 font-medium">{t.industry}</p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2.5 mt-6">
          {testimonials.map((_, i) => (
            <button
              key={i}
              className={`rounded-full transition-all duration-200 cursor-pointer ${
                i === active ? "w-6 h-2.5 bg-electric-500" : "w-2.5 h-2.5 bg-white/20 hover:bg-white/40"
              }`}
              aria-label={`Testimonial ${i + 1}`}
              onClick={() => setActive(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
